import { CLOSE_DEAL } from './closeDeal';
import { REOPEN_DEAL } from './reopenDeal';
import { UPDATE_DEAL_CLOSURE_DATE } from './updateDealClosureDate';

export const dealLifeCycleApi = {
  closeDeal: CLOSE_DEAL,
  reopenDeal: REOPEN_DEAL,
  updateDealClosureDate: UPDATE_DEAL_CLOSURE_DATE,
};

export * from './types';
export * from './useDealLifeCycle';
